import axios from 'axios';
import RouteUrls from '../common/RouteUrls'
import {getXSRFToken} from '../common/authTokenUtil';

export const verifyUserId = async (accountNumber, zipCode, businessPhone) => {
  try {
    const response = await axios({
      method: 'POST',
      url: RouteUrls.VERIFY_USERID,
      headers: {
        'correlation-id':
          '12345',
        'client-id':
          'PNET'
      },
      data: {
        accountNumber: accountNumber.replaceAll("-",""),
        zipCode: zipCode,
        businessPhone: businessPhone.replaceAll("-","")
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error while verifying User Id : ', error);
    throw error;
  }
}

export const enrollCardHolder = async (userId) => {
  try {
    const response = await axios({
      method: 'POST',
      url: RouteUrls.ENROLL_USERID,
      headers: {
        'correlation-id':
          '12345',
        'client-id':
          'PNET',
        'X-XSRF-TOKEN': getXSRFToken()
      },
      data: {
        userId: userId,
        accountNumber: sessionStorage.getItem('accountNumber')
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error while Enrolling Card Holder : ', error);
    throw error;
  }
}